import { render, staticRenderFns } from "./ChineseLibClassify.vue?vue&type=template&id=71e8d202&scoped=true"
import script from "./ChineseLibClassify.vue?vue&type=script&lang=js"
export * from "./ChineseLibClassify.vue?vue&type=script&lang=js"
import style0 from "./ChineseLibClassify.vue?vue&type=style&index=0&id=71e8d202&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e8d202",
  null
  
)

export default component.exports